import {
  CodeReviewerSettingContainerType,
  CodeReviewerWorkspaceSetting,
} from 'src/components/rovo-dev-agents/src/hooks/types';

import { useCodeReviewerSetting } from './use-code-reviewer-setting';

export const useCodeReviewerWorkspaceSetting = (
  forceInvalidateCache = false
): CodeReviewerWorkspaceSetting => {
  const { error, isLoading, workspaceSettings, updateWorkspaceSetting } =
    useCodeReviewerSetting({
      containerType: CodeReviewerSettingContainerType.Workspace,
      forceInvalidateCache,
    });

  return {
    error,
    isLoading,
    workspaceSettings,
    updateWorkspaceSetting,
  };
};
